// export const API_URL = "http://localhost:3001";
// export const API_URL = 'https://3001-firebase-mfscustomergit-1747822525484.cluster-44kx2eiocbhe2tyk3zoyo3ryuo.cloudworkstations.dev'
export const API_URL = "https://api.myfrontseat.in";
